import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getOrderDetailsV2 } from '../../../api/outboundorders/order-details'

const initialState = {
  isFetchingShipmentDetails: false,
  fetchShipmentDetailsError: null,
  orderDetails: null,
  shipmentItemDetails: [],
}

/* TODO:  Add Logic here to call api to fetching shipment details */
export const fetchShipmentDetails = createAsyncThunk(
  'orderDetails/fetchShipmentDetails',
  async (args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      wmsOrderId:
        args?.dmsUser === 'Y'
          ? state.orderList.selectedShipment?.wmsOrderNum
          : state.order.selectedOrder?.wms_order,
      orderStatus:
        args?.dmsUser === 'Y'
          ? state.orderList.selectedShipment?.orderStatus
          : state.order.selectedOrder?.orderStatus,
    }
    try {
      return await getOrderDetailsV2(request)
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const orderDetailsSlice = createSlice({
  name: 'orderDetails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShipmentDetails.pending, (state) => {
        state.isFetchingShipmentDetails = true
        state.fetchShipmentDetailsError = null
        state.orderDetails = null
        state.shipmentItemDetails = []
      })
      .addCase(fetchShipmentDetails.fulfilled, (state, action) => {
        state.isFetchingShipmentDetails = false
        state.orderDetails = action.payload?.data?.data?.orderDetails
        state.shipmentItemDetails = action.payload?.data?.data?.shipmentItemDetails
      })
      .addCase(fetchShipmentDetails.rejected, (state, action) => {
        state.isFetchingShipmentDetails = false
        state.fetchShipmentDetailsError = action.payload
      })
      /* Each time a client is selected, orders are fetched for
         either WMS or DMS so should reset the slice */
      .addCase('order/fetchOrders/pending', () => {
        return initialState
      })
      .addCase('order/searchOrders/pending', () => {
        return initialState
      })
      .addCase('orderAllocationsSummary/fetchOrderAllocationsSummary/pending', () => {
        return initialState
      })
      .addCase('orderAllocations/fetchOrderAllocations/pending', () => {
        return initialState
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export default orderDetailsSlice.reducer
